import type { ChartDataOptions, ChartDataOptionsInternal } from './types';
import type { ChartType } from '@/types';

type AttributeKeysResolver = () => string[];
type MeasureKeysResolver = () => string[];

export type ChartDataOptionsExtension = {
  translate?: (dataOptions: ChartDataOptions) => ChartDataOptionsInternal;
  attributeKeys?: AttributeKeysResolver;
  measureKeys?: MeasureKeysResolver;
};

const chartDataOptionsExtensions = new Map<ChartType, ChartDataOptionsExtension>();

export const registerChartDataOptionsExtension = (
  chartType: ChartType,
  extension: ChartDataOptionsExtension,
) => {
  const currentExtension = chartDataOptionsExtensions.get(chartType) ?? {};
  chartDataOptionsExtensions.set(chartType, {
    ...currentExtension,
    ...extension,
  });
};

export const getChartDataOptionsExtension = (chartType: ChartType) => {
  return chartDataOptionsExtensions.get(chartType);
};

export const clearChartDataOptionsExtensions = () => {
  chartDataOptionsExtensions.clear();
};
